import React from "react"
import logoDefault from "../../../../../assets/img/product.svg"
import { Link } from "react-router-dom"
import {
  calendarGrades,
  grades as gradesNames,
  subjects as subjectsName,
} from "../../../../../library/constants/educationalDictionary"
import MoreDropdown from "../../../../../components/ui/dropdowns/moreDropdown/moreDropdown"
import VerticalMenu from "../../../../../components/ui/verticalMenu"
import ComplaintsModal from "../../../../../components/complaints/complaintsModal"
import { safeGetEntity } from "../../../../../library/utils/entities"
import { getObjectById } from "../../../../../library/utils/arrays"

const KnowMixSquareCard = (props) => {
  const {
    knowmix: {
      creator_user,
      creator_group,
      photo,
      name,
      grades,
      subjects,
      id,
      subject,
    },
    hasMenu,
    menuItems,
    bottomLabel,
    linkUrl,
  } = props
  const knowmixLogo = photo || logoDefault

  // const creatorName = creator_user
  //   ? `${creator_user?.first_name} ${creator_user?.last_name}`
  //   : creator_group?.name
  //
  // const creatorUrl = creator_user
  //   ? generatePath(routes.USER, { userId: creator_user?.id })
  //   : generatePath(routes.GROUP, { groupId: creator_group?.id })

  return (
    <div className="knowmix-card knowmix-card--square">
      <ComplaintsModal
        open={props.complaintsModal === id}
        knowmix_id={id}
        onClose={props.hideComplaintsModal}
        callback={props.updateData}
      />
      {hasMenu && (
        <div className="product-tile__menu">
          <MoreDropdown>
            <VerticalMenu
              menuItems={menuItems}
              classes={"more-dropdown-menu__list"}
            />
          </MoreDropdown>
        </div>
      )}
      <Link to={linkUrl} className="img-container">
        <img src={knowmixLogo} alt="" />
      </Link>
      <Link to={linkUrl} className="name">
        {name}
      </Link>
      <table className="knowmix-card--square__info">
        <tbody>
          {/*<tr>*/}
          {/*  <td className={`knowmix-card--square__info-label pb4`}>*/}
          {/*    <span>Creator:</span>*/}
          {/*  </td>*/}
          {/*  <td className={`knowmix-card--square__info-value pb4`}>*/}
          {/*                    <span>*/}
          {/*                        <Link to={creatorUrl}*/}
          {/*                              className="link">{creatorName}</Link>*/}
          {/*                    </span>*/}
          {/*  </td>*/}
          {/*</tr>*/}
          {!!safeGetEntity(subject) && (
            <tr>
              <td className="knowmix-card--square__info-label pb4">
                <span>Subject:</span>
              </td>
              <td className="knowmix-card--square__info-value pb4">
                {`${getObjectById(calendarGrades, subject.grade).name} grade, ${
                  subject.name
                }`}
              </td>
            </tr>
          )}
          {!!subjects.length && (
            <tr>
              <td className="knowmix-card--square__info-label pb4">
                <span>Subjects:</span>
              </td>
              <td className="knowmix-card--square__info-value pb4">
                <span>
                  {subjects
                    .map((id) => subjectsName.find((s) => s.id === id).name)
                    .join(", ")}
                </span>
              </td>
            </tr>
          )}
          {!!grades.length && (
            <tr>
              <td className="knowmix-card--square__info-label pb4">
                <span>Grades:</span>
              </td>
              <td className="knowmix-card--square__info-value pb4">
                <span>
                  {grades
                    .map((id) => gradesNames.find((g) => g.id === id).name)
                    .join(", ")}
                </span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="h-divider h-divider--vertical-margin"></div>
      <div className="knowmix-card--square__status">
        <span className="knowmix-card--square__status-value">
          {bottomLabel}
        </span>
      </div>
    </div>
  )
}

export default KnowMixSquareCard
